import { IApiPricingRule, IApiPricingRuleUpdate, IApiRuleId } from '@cbridge-packages/api';
import { RuleTranslator } from '@cbridge-packages/rule';
import { IPricingRule, IPricingImportRule } from './pricingRule.interface';

export namespace PricingRuleTranslator {
  export function fromApi(rule: IApiPricingRule): IPricingRule {
    return RuleTranslator.fromApiClientRule(rule);
  }

  export function toApi(rule: IPricingRule): IApiPricingRuleUpdate {
    return RuleTranslator.toApiClientRule(rule);
  }

  export function fromApiImport(rule: IApiPricingRule & IApiRuleId): IPricingImportRule {
    const result: IPricingImportRule = RuleTranslator.fromApiClientRule(rule);
    result.id = rule.id;

    return result;
  }
}
